import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "resource-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "top-area"
}
const _hoisted_3 = {
  key: 1,
  class: "middle-area mmt-6"
}
const _hoisted_4 = {
  key: 2,
  class: "bottom-area mmt-6"
}

import Loading from '@shell/components/Loading.vue';

interface Props {
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Page',
  props: {
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.loading)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.$slots['top-area'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "top-area")
              ]))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (_ctx.$slots['middle-area'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "middle-area")
              ]))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (_ctx.$slots['bottom-area'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "bottom-area")
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})